var TagName = /*#__PURE__*/function (TagName) {
  TagName["Input"] = "INPUT";
  TagName["Textarea"] = "TEXTAREA";
  TagName["Button"] = "BUTTON";
  TagName["Anchor"] = "A";
  return TagName;
}({});

export { TagName };
//# sourceMappingURL=html.js.map
